<template>
    <span class="love">love</span><span class="pod">pod</span><span class="heart">&hearts;</span>
</template>

<script>
export default {
    name: 'Lovepod'
}
</script>
<style lang="css" scoped>

    span.love,
    span.heart
    {
        color: #990000;
    }

    span.heart
    {
        display: inline-block;
        font-size: 0.7em;
        margin-left: 2px;
        position: relative;
        top: -5px;
        transform: rotate( -20deg );
    }

    span.pod
    {
        color: #3c3c3c;
    }

</style>